export const SET_TICKET_ID = 'SET_TICKET_ID'
export const REMOVE_TICKET_ID = 'REMOVE_TICKET_ID'
export const PAID_TICKET_ID = 'PAID_TICKET_ID'
export const SET_TICKET_PRICE = 'SET_TICKET_PRICE'
export const CHECK_TICKET_STATUS = 'CHECK_TICKET_STATUS'

export function setTicketId (ticketId) {
  return {
    type: SET_TICKET_ID,
    payload: {
      item: ticketId,
      lastUpdated: Date.now()
    }
  }
}

export function setTicketPrice (revenue, delivery, gst, items) {
  return {
    type: SET_TICKET_PRICE,
    payload: {
      revenue,
      delivery,
      gst,
      items
    }
  }
}

export function removeTicketId () {
  return {
    type: REMOVE_TICKET_ID
  }
}

export function setPaidTicketId () {
  return {
    type: PAID_TICKET_ID
  }
}

export function checkTicketStatus () {
  return {
    type: CHECK_TICKET_STATUS
  }
}
